import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router, { setupRouterGuards } from './router'
import { useUiStore } from './stores/ui'
import { applyProjectLocale, installLocaleSync } from './utils/localeBootstrap'

// Estilos
// NOTA: Bootstrap npm debe cargarse ANTES de global.css: el tema (core.css) NO es un
// build completo — le faltan variantes .btn-*, .pagination y otras; solo sobreescribe.
import 'bootstrap/dist/css/bootstrap.min.css'
import * as bootstrap from 'bootstrap'
import 'leaflet/dist/leaflet.css'
import './assets/styles/font-awesome/ajax/libs/font-awesome/6.4.2/css/all.min.css'
import './assets/styles/local-fonts.css'
import 'select2/dist/css/select2.min.css'
import 'flatpickr/dist/flatpickr.min.css'
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css'
import './assets/styles/global.css'
import './assets/styles/theme.css'
import Swal from 'sweetalert2'

// Librerías
import L from 'leaflet'
import markerIcon from './assets/images/marker-icon.png'
import markerIcon2x from './assets/images/marker-icon-2x.png'
import markerShadow from './assets/images/marker-shadow.png'
import $ from 'jquery'
import dataTables from 'datatables.net-bs5'
import './utils/utils.js'

// Datatype initialization
const app = createApp(App)
app.use(createPinia())

// Tema (claro/oscuro): aplica data-theme/data-bs-theme antes del mount
useUiStore().initTheme()

// Formato Regional (locale) del proyecto activo: aplica separador decimal/de
// miles y locale de Day.js ANTES del mount, para que el primer render ya salga
// bien formateado. installLocaleSync() lo mantiene al día en cada cambio de
// proyecto o de sesión (escucha 'hb:session-updated').
applyProjectLocale()
installLocaleSync()

// Hacer Leaflet disponible globalmente
window.L = L
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow
})
window.$ = $
window.jQuery = $
window.Swal = Swal
window.bootstrap = bootstrap

// Registra DataTables contra la misma instancia global de jQuery usada por la app.
if (!$.fn?.dataTable) {
  dataTables(window, $)
}

// Global properties
app.config.globalProperties.menuIsReady = { value: false }
app.config.globalProperties.proyectos = { value: [] }
app.config.globalProperties.usuarioActual = null
app.config.globalProperties.showBoot = () => {
  const el = document.getElementById('boot')
  if (el) el.classList.remove('hidden')
}
app.config.globalProperties.hideBoot = () => {
  const el = document.getElementById('boot')
  if (el) el.classList.add('hidden')
}

// Configurar guards del router
setupRouterGuards(app)

app.use(router)
app.mount('#app')
